import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
import Err from "../../../routes/error";
import TemplateEmailModal from "./modals/template-email-modal";
import SaveTemplateModal from "./modals/save-template-modal";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { UPDATE_EMAIL_TEMPLATE, CREATE_EMAIL_TEMPLATE, REMOVE_EMAIL_TEMPLATE, LOAD_EMAIL_TEMPLATE, LOAD_EMAIL_TEMPLATES } from "@Broker/@Modules/clients/board/store/board-actions";
import { showToast, EMAIL_TEMPLATE_TYPES } from "@Shared/utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EmailEditorTemplates",
  components: {
    TemplateEmailModal,
    SaveTemplateModal,
    SimpleButton
  },
  props: {
    rawHtml: {
      type: String,
      default: ""
    },
    onlyActionButton: {
      type: Boolean,
      default: false
    },
    subject: {
      type: String,
      default: ""
    },
    attachments: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      loadedTemplate: {},
      saveAsNew: false,
      savingTemplate: false,
      withAttachments: true,
      showSaveWithAttachmentsPopover: false
    };
  },
  computed: _objectSpread(_objectSpread({
    storedEmailsDropdownId() {
      return `stored-emails-dropdown`;
    }
  }, mapState("BoardStore", {
    templates(state) {
      var _state$emailTemplates;
      return ((_state$emailTemplates = state.emailTemplates) == null ? void 0 : _state$emailTemplates.byId) || {};
    }
  })), {}, {
    getAttachments() {
      return this.withAttachments ? this.attachments : [];
    }
  }),
  mounted() {
    this.LOAD_EMAIL_TEMPLATES();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [CREATE_EMAIL_TEMPLATE, UPDATE_EMAIL_TEMPLATE, REMOVE_EMAIL_TEMPLATE, LOAD_EMAIL_TEMPLATE, LOAD_EMAIL_TEMPLATES])), {}, {
    clearAfterHide() {
      this.saveAsNew = false;
      this.showSaveWithAttachmentsPopover = false;
    },
    handleUpdateTemplate() {
      this.saveAsNew = false;
      this.withAttachments = true;
      this.$refs.saveTemplateModal.$showModal();
    },
    handleSaveAsNewClick() {
      if (!this.rawHtml) return;
      this.saveAsNew = true;
      if (this.attachments.length > 0) {
        this.showSaveWithAttachmentsPopover = true;
      } else {
        this.$refs.saveTemplateModal.$showModal();
      }
    },
    loadEmailTemplatesModal() {
      $("#timeline-email-list-modal").modal("show");
    },
    async saveTemplate(name, description, subject, attachments) {
      this.savingTemplate = true;
      const emailData = {
        html: this.rawHtml,
        subject,
        name,
        description,
        attachments,
        templateType: EMAIL_TEMPLATE_TYPES.CLIENT_PROFILE
      };
      if (!this.loadedTemplate.id || this.saveAsNew) {
        const id = await this.CREATE_EMAIL_TEMPLATE({
          emailData
        });
        this.loadedTemplate = _objectSpread(_objectSpread({}, emailData), {}, {
          id
        });
      } else {
        await this.UPDATE_EMAIL_TEMPLATE({
          templateId: this.loadedTemplate.id,
          emailData
        });
        this.loadedTemplate = _objectSpread(_objectSpread({}, this.loadedTemplate), emailData);
      }
      this.$emit("selected", this.loadedTemplate);
      this.savingTemplate = false;
      showToast("success", "templateSaved");
      this.$refs.saveTemplateModal.$hideModal();
    },
    clearTemplate() {
      this.loadedTemplate = {};
      this.showSaveWithAttachmentsPopover = false;
      this.$emit("clear");
    },
    async handleTemplateSelect(templateId) {
      const data = this.templates[templateId];
      const {
        html,
        subject,
        attachments
      } = await this.LOAD_EMAIL_TEMPLATE({
        templateId
      });
      this.loadedTemplate = _objectSpread({
        html,
        subject,
        attachments
      }, data);
      this.$emit("selected", this.loadedTemplate);
    },
    async handleTemplateDelete(templateId) {
      try {
        await this.REMOVE_EMAIL_TEMPLATE({
          templateId
        });
      } catch (e) {
        Err.handle(e);
      }
    },
    handleSaveWithAttachments(withAttachments) {
      this.withAttachments = withAttachments;
      this.showSaveWithAttachmentsPopover = false;
      this.$refs.saveTemplateModal.$showModal();
    }
  })
});